import React, { useEffect, useRef } from "react";
import { FaExternalLinkAlt, FaCopy, FaTimes } from "react-icons/fa";
import "../../css/View/PreviewPopup.css";
import { useToast } from "../../Contexts/ToastContext";


const PreviewPopup = ({ url, title = "Podgląd", onClose }) => {
  const dialogRef = useRef(null);
const { showToast } = useToast();
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const openUrl = () => {
    window.open(url, "_blank", "noopener,noreferrer");
    onClose?.();
  };

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(url);
       showToast("Skopiowano link do schowka!", "info");
      onClose?.();
    } catch {
      if (dialogRef.current) {
        const input = dialogRef.current.querySelector("input");
        input?.select();
        document.execCommand?.("copy");
        alert("Skopiuj ręcznie zaznaczony link");
      }
    }
  };

  return (
    <div className="preview-popup-overlay" onClick={onClose}>
      <div
        className="preview-popup"
        ref={dialogRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="preview-popup-close" onClick={onClose}>
          <FaTimes />
        </div>

        <h3 className="preview-popup-title">{title}</h3>

        <input
          className="preview-popup-input"
          type="text"
          value={url}
          readOnly
          onFocus={(e) => e.target.select()}
        />

        <div className="preview-popup-actions">
                      <div className="preview-popup-btn" onClick={copyUrl}>
            <FaCopy className="icon" /> Kopiuj link
          </div>
          <div className="preview-popup-btn primary" onClick={openUrl}>
            <FaExternalLinkAlt className="icon" /> Otwórz
          </div>

        </div>
      </div>
    </div>
  );
};

export default PreviewPopup;
